import { render, staticRenderFns } from "./TabelCustomer.vue?vue&type=template&id=9cc2b4aa"
import script from "./TabelCustomer.vue?vue&type=script&lang=js"
export * from "./TabelCustomer.vue?vue&type=script&lang=js"
import style0 from "./TabelCustomer.vue?vue&type=style&index=0&id=9cc2b4aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports